import { NavLink } from "react-router"

import { Button } from "@/components/ui/button"

export default function ForHireHeader() {
  return (
    <div className="mb-3">
      <NavLink to={"/dashboards/For-Hire"} end>
        {({ isActive }) => (
          <Button
            variant="outline"
            className={`rounded-r-none ${isActive && "text-accent-foreground"}`}
          >
            For Hire Dashboard
          </Button>
        )}
      </NavLink>
      <NavLink to={"/dashboards/For-Hire/balance"}>
        {({ isActive }) => (
          <Button
            variant="outline"
            className={`rounded-l-none border-l-0 ${isActive && "text-accent-foreground"}`}
          >
            Load Balance Board
          </Button>
        )}
      </NavLink>
    </div>
  )
}
